import { Backdrop, styled } from '@mui/material';

export const BackdropWrapper = styled(Backdrop)(({ theme }) => ({
  zIndex: theme.zIndex.drawer + 1,
  color: theme.palette.common.white
}));
